<div [class.empleados-seleccion-modal]="modoSeleccionFirmante">
  <button
    *ngIf="modoSeleccionFirmante"
    type="button"
    class="empleados-seleccion-modal__close"
    mat-dialog-close
    aria-label="Cerrar">
    <svg class="icon-close" aria-hidden="true">
      <use xlink:href="#icon-close"></use>
    </svg>
  </button>

  <div class="barra-flex-space-between" [class.barra-flex-space-between--modal]="modoSeleccionFirmante">
    <h1>{{ modoSeleccionFirmante ? 'Firmante' : 'Gestión empleados' }}</h1>
    <div class="acciones" *ngIf="!modoSeleccionFirmante">
      <app-empleados-barra-superior (botonClicked)="clickBarraSuperior($event)"></app-empleados-barra-superior>
      <app-boton-accion [id]="'importar'" [icono]="'hs-upload'" [titulo]="'importar'" [outline]="true"  [cancelar]="true" (click)="goToImportEmpleados()"></app-boton-accion>
      <app-boton-accion [id]="'nuevo empleado'" [icono]="'icon-plus'" [titulo]="'nuevo empleado'" [outline]="false" (click)="creaNuevoEmpleado()"></app-boton-accion>
    </div>
  </div>

  <div class="main" [class.main--modal-seleccion]="modoSeleccionFirmante">
    <div [style.display]="mostrarBarraBusqueda ? 'flex' : 'none'" class="flex-center-items">
      <app-input-buscador (buscador)="buscarEmpleados($event)" [textoBuscar]="textoBuscar"></app-input-buscador>
      <app-empleados-filtros (filtrosNuevosEmitter)="filtrarEmpleados($event)"
                             [textoBuscar]="textoBuscar"
                             [empresasList]="empresasLista"
                             [centrosList]="centrosLista"
                             (limpiarBuscador)="buscarEmpleados($event)">
      </app-empleados-filtros>
    </div>
    <app-pastilla-seleccion-multiple *ngIf="!modoSeleccionFirmante && empleadosSeleccionados.length>0"
                                     (borrarEmitter)="deleteEmpleado()"
                                     (deseleccionarEmitter)="deseleccionarAll()"
                                     [textoMostrar]="textoBorrar"
                                     [tipoDato]="'empleados'"></app-pastilla-seleccion-multiple>
    <div [class.empleados-seleccion-grid]="modoSeleccionFirmante">
      <app-sqp-grid-component #sqpGrid
                              [data]="empleados"
                              [columnDefs]="columnDefs"
                              [seleccion]="modoSeleccionFirmante ? 'single' : 'multiple'"
                              [suppressSelectionEvents]="gridSuppressSelectionEvents"
                              (seleccionEliminarEmitter)="seleccionEmpleados($event)"
                              (headerSelectionToggled)="onHeaderSelectionToggled($event)"
                              (abrirModalDataEmitter)="abreModal($event)"
                              [iconoEditar]="!modoSeleccionFirmante"
                              (ordenColumnaEmitter)="ordenarGrid($event)"
                              (onScrollEnd)="loadRows()"
                              (gridReadyEmitter)="onGridReadySeleccionFirmante()"
                              [gridOptions]="gridOptions">
      </app-sqp-grid-component>
    </div>
  </div>

  <div *ngIf="modoSeleccionFirmante" class="empleados-seleccion-footer">
    <app-boton-accion
      mat-dialog-close
      [icono]="'icon-close'"
      [titulo]="'Cancelar'"
      [id]="'Cancelar seleccion firmante'"
      [outline]="true"
      [cancelar]="true">
    </app-boton-accion>
    <app-boton-accion
      [id]="'Anadir firmante'"
      [icono]="'icon-plus'"
      [titulo]="'Añadir firmante'"
      [outline]="false"
      [disabled]="empleadosSeleccionados.length === 0"
      (click)="confirmarAnadirFirmante()">
    </app-boton-accion>
  </div>
</div>
